<template>
  <div class="container">
    <h3 style="text-align:center;font-size:20px;height:80px;line-height:80px;color:#333333;">资料下载详细</h3>
    <div class="detailBox">
      <div class="leftBox">
        <img :src="imgUrl ? imgUrl : placeHoderImgUrl"
             alt="">

        <div class="download">
          <el-progress v-if="loading" :percentage="download.percentage"></el-progress>
          <div class="downLoadButton"
              @click="handleDownload"
              v-loading="loading">下载</div>
          </div>
      </div>
      <div class="rightBox">
        <h4>{{docName}}</h4>
        <span>下载次数：{{downloadCount}}</span>
        <p>{{discribe}}</p>
      </div>
    </div>
  </div>
</template>
<script>
import { downLoad } from '@/utils'
import Cookies from 'js-cookie'
import { getAccessToken } from '@/utils/userInfo'
// import qs from 'qs'
export default {
  data () {
    return {
      loading: false,
      download: {
        percentage: 0
      },
      imgUrl: null,
      placeHoderImgUrl: '../../../../assets/img/占位图_en.png',
      docName: null,
      downloadCount: 0,
      discribe: null,
      userId: null
    }
  },
  mounted () {
    this.getUserId()
    this.addView()
    this.getDataDetail()
  },
  beforeDestroy () {
    window._axiosPromiseArr.forEach(cancel => {
      cancel()
    })
  },
  methods: {
    // 获取详情
    getDataDetail () {
      this.$http.get(`/front/train/trainDocumentManagement/info/${this.$route.query.id}`)
        .then(({ data: res }) => {
          if (res.code === 0) {
            this.imgUrl = res.data.imgurl
            this.docName = res.data.docName
            this.downloadCount = res.data.downloadCount
            this.discribe = res.data.discribe
          } else {
            this.$Message.error(res.msg)
          }
        }).catch(() => {
        })
    },
    // 点击增加浏览次数
    addView () {
      this.$http.post(`/front/train/trainQuestionAnswer/plusViewCount`, {
        type: 5, // type --1:新闻/2：课程/3：图书/4：问答/5：资料下载
        id: this.$route.query.id
      }).then(data => { })
        .catch(() => { })
    },
    // 获取userId
    getUserId () {
      this.userId = Cookies.get('userId')
    },
    downloadIamge (imgsrc, name) { // 下载图片地址和图片名
      var image = new Image()
      // 解决跨域 Canvas 污染问题
      image.setAttribute('crossOrigin', 'anonymous')
      image.onload = function () {
        var canvas = document.createElement('canvas')
        canvas.width = image.width
        canvas.height = image.height
        var context = canvas.getContext('2d')
        context.drawImage(image, 0, 0, image.width, image.height)
        var url = canvas.toDataURL('image/png') // 得到图片的base64编码数据

        var a = document.createElement('a') // 生成一个a元素
        var event = new MouseEvent('click') // 创建一个单击事件
        a.download = name || 'photo' // 设置图片名称
        a.href = url // 将生成的URL设置为a.href属性
        a.dispatchEvent(event) // 触发a的单击事件
      }
      image.src = imgsrc
    },
    downs () {
      this.downloadIamge(this.pic.url, 'pic')
    },
    IsPicture (path) {
      // 判断是否是图片 - strFilter必须是小写列举
      var strFilter = '.jpeg|.gif|.jpg|.png|.bmp|.pic|.svg|'
      if (path.indexOf('.') > -1) {
        var p = path.lastIndexOf('.')
        var strPostfix = path.substring(p, path.length) + '|'
        strPostfix = strPostfix.toLowerCase()
        if (strFilter.indexOf(strPostfix) > -1) {
          return true
        }
      }
      return false
    },
    saveRecord (id) {
      // 埋点
      this.$http.post(`${window.SITE_CONFIG['apiURL']}/front/consumer/knowledgeTrainRecord/save`, {
        userId: this.userId,
        eventId: 'DATA_DOWNLOAD',
        eventType: 'click',
        desc: '资料下载',
        source: 'PC',
        stayTime: '',
        busId: id
      })
    },
    // 下载
    handleDownload () {
      if (this.loading) return
      if (getAccessToken()) {
        var params = {
          id: this.$route.query.id,
          userId: this.userId
        }
        this.$http.get(`/front/train/trainDocumentManagement/download`, {
          params
        }).then(async ({ data: res }) => {
          this.saveRecord(this.$route.query.id)
          if (res.code === 0) {
            var path = res.data.url
            this.loading = true
            downLoad(path, res.data.fileName)
            this.download.percentage = 0
            this.loading = false
            // var isPitcure = this.IsPicture(path)
            // if (isPitcure === true) {
            //   this.downloadIamge(res.data.url, res.data.fileName)
            // } else {
            //   window.location.href = res.data.url
            // }
          }
        })
        // window.location.href = `${window.SITE_CONFIG['apiURL']}/front/train/trainDocumentManagement/download?${qs.stringify(params)}`
      } else {
        this.$confirm(
          `请登录`,
          '提示',
          {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }
        ).then(() => {
          this.$router.push({ name: 'login' })
        })
      }
    }
  }
}
</script>
<style scoped lang="scss">
.container {
  background: white;
  min-height: 400px;
}
.detailBox {
  /* width: 60%; */
  margin: 0 auto;
  background: white;
}
.leftBox {
  display: inline-block;
  padding: 20px 40px;
}
.leftBox img {
  width: 300px;
  height: 300px;
}
.rightBox {
  vertical-align: top;
  display: inline-block;
  padding: 20px 40px;
  /* width: 300px;
  float: right; */
}
.rightBox h4 {
  height: 30px;
  font-size: 16px;
  color: #333333;
}
.rightBox span {
  font-size: 14px;
  color: #1d65a8;
  height: 40px;
  line-height: 40px;
}
.leftBox img {
  width: 300px;
}
.downLoadButton {
  width: 100px;
  height: 40px;
  line-height: 40px;
  background: #1e64a9;
  color: white;
  cursor: pointer;
  text-align: center;
  margin: 20px auto;
}
.downLoadButton:hover {
  background: #18538e;
}
.download {
  position: relative;
}

.el-progress {
  position: absolute;
  cursor: pointer;
  z-index: 2001;
  left: 10%;
  bottom: -20px;
  width: 80%;

  /deep/ .el-progress-bar {
    padding-right: 60px;
    margin-right: -60px;
  }

  /deep/ .el-progress__text {
    position: absolute;
    right: 0;
  }
}
</style>
